<template>
    <div class="vx-col">
        <!-- Кнопка открытия модалки с ранее загруженными файлами -->
        <vs-button @click="openFileModal()" color="primary" class="vx-col" type="border">{{$t('select_file')}}</vs-button>

        <!-- Модалка со списком файлов -->
        <vs-popup
        class="emc_file_popup"
        :title="$t('select_file')"
        :active.sync="activePromptFile">
            <div class="old_file_list">
                <div v-show="!getOldFiles.length">{{$t('no_files')}}</div>
                <div
                    class="mb-2 file_item px-2 py-2"
                    v-for="(file, index) in getOldFiles"
                    :key="`old_${index}`">
                        <div class="flex items-center justify-between">
                            <!-- Ссылка на скачку файла для просмотра -->
                            <a :href="file.file.path" target="_blank" style="font-weight:bold;" class="name">{{file.name}} ({{file.file.name}})</a>

                            <!-- Выбор файла -->
                            <vs-checkbox v-model="selected" :vs-value="file" ></vs-checkbox>
                        </div>
                        <!-- Список дисциплин к которым уже был прикреплен файл -->
                        <div class="dis_list mt-2 pt-2 border-t border-l-0 border-r-0 border-b-0 d-theme-border-grey-light border-solid" v-if="file.disciplines && file.disciplines.length">
                            <label>{{$t('previously_attached')}}</label>
                            <div class="dis_item" v-for="(dis, index) in file.disciplines" :key="`dis_${index}`">
                                {{dis}}
                            </div>
                        </div>
                </div>
                <div class="sticky_action flex">
                    <!-- Кнопки выбрать файлы и очистить -->
                    <vs-button :disabled="!selected.length && true" class="mr-2" @click="fileHandler()">{{$t('select')}}</vs-button>
                    <vs-button :disabled="!selected.length && true" @click="selected = []" color="primary" type="border">{{$t('clear')}}</vs-button>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
    props: {
        fileSelectHandler: {
            type: Function,
            default: () => {}
        },
        formFiles: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            activePromptFile: false,
            selected: []
        }
    },
    computed: {
        getOldFiles() {
            // Фильтром скрываем из списка ранее выбранные файла
            let files = this.$store.getters['emc/getOldFiles']
            if(this.formFiles.length) {
                return files.filter(item => {
                    const file = this.formFiles.find(file => file.uid === item.uid)
                    if(file) {
                        return item.uid !== file.uid
                    } else
                        return true
                })
            } else
                return files
        }
    },
    methods: {
        ...mapActions({
            fetchAllFiles: "emc/fetchAllFiles"
        }),
        fileHandler() {
            // При нажатии на кнопку выбрать, передаем все выбранные файлы в родительскую функцию, закрываем окно и очищаем выбранные файлы
            this.activePromptFile = false
            this.fileSelectHandler(this.selected)
            this.selected = []
        },
        async openFileModal () {
            // Получаем список ранее загруженных пользователем файлов
            try {
                this.$vs.loading()
                const res = await this.fetchAllFiles()
                if(res.length) this.activePromptFile = true
                else this.$vs.notify({ text: this.$t('no_files2'), color:'warning' })
            } catch(error) {
                this.$vs.notify({ title:'Предупреждение!', text: error, color:'danger' })
            } finally {
                this.$vs.loading.close()
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.dis_list{
    label{
        font-weight: 500;
        font-size: 12px;
    }
    .dis_item{
        &:not(:last-child){
            margin-bottom: 5px;
        }
    }
}
</style>
<style lang="scss">
.old_file_list{
    .sticky_action{
        position: sticky;
        bottom: -15px;
        z-index: 0;
        left: 0;
        width: 100%;
        background: #ffffff;
        padding: 5px 0px;
    }
    .file_item{
        background: #f7f7f7;
    }
}
.emc_file_popup{
    z-index: 55000;
    .vs-popup--content{
        position: relative;
    }
}
</style>
